import React, { useEffect, useRef, useState } from "react";
import styles from "../styles/MiloDemo.module.css";

const MiloDemo = ({ setStep }) => {
  const [approvals, setApprovals] = useState([]);
  const [showFinalApproval, setShowFinalApproval] = useState(false);
  const timeoutsRef = useRef([]);

  useEffect(() => {
    setApprovals([]);
    setShowFinalApproval(false);

    const approvalList = [
      "Fenway Field Apartments - Approved ✅",
      "100 Summer St Apartments - Approved ✅",
      "Cambridge Landing - Approved ✅",
    ];

    approvalList.forEach((approval, i) => {
      const timeout = setTimeout(() => {
        setApprovals((prev) => [...prev, approval]);
      }, i * 1200);
      timeoutsRef.current.push(timeout);
    });

    // Set showFinalApproval 1 second after the last item is added
    const finalTimeout = setTimeout(() => {
      setShowFinalApproval(true);
    }, approvalList.length * 1200 + 1); // Wait 1 extra second
    timeoutsRef.current.push(finalTimeout);
	
	return () => {
      timeoutsRef.current.forEach(clearTimeout);
      timeoutsRef.current = [];
    };
  }, []);

  return (
    <div className={styles["miloDemoContainer"]}>
      <div className={styles["miloDemoLeft"]}>
        <h2 className={styles["demoHeading"]}>See How MILO Works in Action</h2>
        <p className={styles["demoSubtext"]}>
          Forget the back-and-forth of traditional renting.
        </p>
        <div className={styles["approvalsList"]}>
          {approvals.map((approval, index) => (
            <p key={index} className={styles["approvalItem"]}>
              {approval}
            </p>
          ))}
          {showFinalApproval && (
			  <p className={styles["moreComing"]}>More coming soon...</p>
          )}
        </div>
      </div>
      <div className={styles["miloDemoRight"]}>
        <div className={styles["propertyHighlight"]}>
          <h3 className={styles["propertyTitle"]}>🏡 Fenway Field Apartments</h3>
          <p className={styles["propertyLocation"]}>📍 Prime location in Boston</p>
          <div className={styles["propertyDetails"]}>
            <p>💰 No security deposit required</p>
            <p>✨ Move-in ready & hassle-free</p>
          </div>
          <button
            className={styles["exploreMapButton"]}
            onClick={() => setStep(3)}
          >
            Explore on the Map →
          </button>
        </div>
      </div>
    </div>
  );
};

export default MiloDemo;


